import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";

const SET_IS_LOADING = "lounge/SET_IS_LOADING";
const SET_OUTFIT_LIST = "lounge/SET_OUTFIT_LIST";
const INIT_ALL_DATA = "lounge/INIT_ALL_DATA";

const setIsLoading = createAction(SET_IS_LOADING);
const setOutfitList = createAction(SET_OUTFIT_LIST);
const initAllData = createAction(INIT_ALL_DATA);

const getLoungeState = ({ getState }) => {
  const loungeState = getState().lounge.toJS();
  return loungeState;
};

const requestLoungeList = async () => {
  const { code, res, errInfo } = await Restful.getLoungeListAPI();
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    return { list: res.list };
  }
};

const setLoungeList = async ({ dispatch }) => {
  const { list } = await requestLoungeList();
  dispatch(setOutfitList(list));
};

export const initList = () => async (dispatch, getState) => {
  const loungeState = getLoungeState({ getState });
  const { outfitList, isLoading } = loungeState;

  if (isLoading) return null;

  if (!!outfitList && outfitList.length > 0) return null;

  dispatch(setIsLoading(true));
  await setLoungeList({ dispatch });
  dispatch(setIsLoading(false));
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  outfitList: [],
  isLoading: false
});

export default handleActions(
  {
    [SET_IS_LOADING]: (state, action) => {
      const isLoading = action.payload;
      return state.set("isLoading", fromJS(isLoading));
    },
    [SET_OUTFIT_LIST]: (state, action) => {
      const outfitList = action.payload;
      return state.set("outfitList", fromJS(outfitList));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
